// Generated by purs version 0.15.15
import * as Data_Array_NonEmpty_Serialized from "../Data.Array.NonEmpty.Serialized/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Map_Serialized from "../Data.Map.Serialized/index.js";
import * as Data_MultiSet_Serialized from "../Data.MultiSet.Serialized/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Set_Serialized from "../Data.Set.Serialized/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic_Menu_V2_Types_InternalParameterId from "../Restaumatic.Menu.V2.Types.InternalParameterId/index.js";
import * as Restaumatic_Menu_V2_Types_ParameterId from "../Restaumatic.Menu.V2.Types.ParameterId/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId);
var eq1 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Set_Serialized.eqSet(Restaumatic_Menu_V2_Types_ParameterId.eqParameterId));
var eq2 = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Menu_V2_Types_InternalParameterId.eqInternalParameterId);
var eqMap = /* #__PURE__ */ Data_Map_Serialized.eqMap(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId);
var eq3 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ eqMap(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId));
var eq4 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ eqMap(/* #__PURE__ */ Data_MultiSet_Serialized.eqMultiSet(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)));
var ordMap = /* #__PURE__ */ Data_Map_Serialized.ordMap(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId);
var compare = /* #__PURE__ */ Data_Ord.compare(/* #__PURE__ */ ordMap(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId));
var compare1 = /* #__PURE__ */ Data_Ord.compare(/* #__PURE__ */ ordMap(/* #__PURE__ */ Data_MultiSet_Serialized.ordMultiSet(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)));
var compare2 = /* #__PURE__ */ Data_Ord.compare(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId);
var genericShowArgsArgument = /* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId);
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(genericShowArgsArgument);
var ParameterChoiceNotAvailableIsSymbol = {
    reflectSymbol: function () {
        return "ParameterChoiceNotAvailable";
    }
};
var InvalidModifierItemCountIsSymbol = {
    reflectSymbol: function () {
        return "InvalidModifierItemCount";
    }
};
var genericShowConstructor1 = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsProduct(genericShowArgsArgument)(genericShowArgsArgument));
var InvalidModifierItemDuplicateCountIsSymbol = {
    reflectSymbol: function () {
        return "InvalidModifierItemDuplicateCount";
    }
};
var ModifierItemNotAvailableIsSymbol = {
    reflectSymbol: function () {
        return "ModifierItemNotAvailable";
    }
};
var IrremovableModifierItemIsSymbol = {
    reflectSymbol: function () {
        return "IrremovableModifierItem";
    }
};
var ComboNotAvailableIsSymbol = {
    reflectSymbol: function () {
        return "ComboNotAvailable";
    }
};
var ProductNotAvailableIsSymbol = {
    reflectSymbol: function () {
        return "ProductNotAvailable";
    }
};
var decodeSingleConstructorAr1 = /* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId);
var genericDecodeManyArgsArgu = /* #__PURE__ */ Unscramble_Generic.genericDecodeManyArgsArgu(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId);
var genericDecodeSumConstruct1 = /* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgs1(/* #__PURE__ */ Unscramble_Generic.genericDecodeManyArgsProd(genericDecodeManyArgsArgu)(genericDecodeManyArgsArgu)));
var MissingParametersIsSymbol = {
    reflectSymbol: function () {
        return "MissingParameters";
    }
};
var genericShowConstructor2 = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var MissingValueIsSymbol = {
    reflectSymbol: function () {
        return "MissingValue";
    }
};
var genericDecodeSumConstruct11 = /* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume);
var ProductNotFoundIsSymbol = {
    reflectSymbol: function () {
        return "ProductNotFound";
    }
};
var CategoryNotFoundIsSymbol = {
    reflectSymbol: function () {
        return "CategoryNotFound";
    }
};
var DistinctCategoriesIsSymbol = {
    reflectSymbol: function () {
        return "DistinctCategories";
    }
};
var TooManyPartsIsSymbol = {
    reflectSymbol: function () {
        return "TooManyParts";
    }
};
var ParameterNotFoundIsSymbol = {
    reflectSymbol: function () {
        return "ParameterNotFound";
    }
};
var ParametricErrorIsSymbol = {
    reflectSymbol: function () {
        return "ParametricError";
    }
};
var CustomParameterNotSetIsSymbol = {
    reflectSymbol: function () {
        return "CustomParameterNotSet";
    }
};
var InternalParameterNotSetIsSymbol = {
    reflectSymbol: function () {
        return "InternalParameterNotSet";
    }
};
var InvalidParameterValueIsSymbol = {
    reflectSymbol: function () {
        return "InvalidParameterValue";
    }
};
var ModifierNotFoundIsSymbol = {
    reflectSymbol: function () {
        return "ModifierNotFound";
    }
};
var ModifierNotSetIsSymbol = {
    reflectSymbol: function () {
        return "ModifierNotSet";
    }
};
var InvalidModifierValueIsSymbol = {
    reflectSymbol: function () {
        return "InvalidModifierValue";
    }
};
var ComboNotFoundIsSymbol = {
    reflectSymbol: function () {
        return "ComboNotFound";
    }
};
var ComboElementNotSetIsSymbol = {
    reflectSymbol: function () {
        return "ComboElementNotSet";
    }
};
var InvalidComboChoiceIsSymbol = {
    reflectSymbol: function () {
        return "InvalidComboChoice";
    }
};
var AvailabilityScheduleNotFoundIsSymbol = {
    reflectSymbol: function () {
        return "AvailabilityScheduleNotFound";
    }
};
var VariantNotAvailableIsSymbol = {
    reflectSymbol: function () {
        return "VariantNotAvailable";
    }
};
var PackagingContainerNotFoundIsSymbol = {
    reflectSymbol: function () {
        return "PackagingContainerNotFound";
    }
};
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var customParametersIsSymbol = {
    reflectSymbol: function () {
        return "customParameters";
    }
};
var showRecordFieldsCons = /* #__PURE__ */ Data_Show.showRecordFieldsCons(customParametersIsSymbol);
var modifiersIsSymbol = {
    reflectSymbol: function () {
        return "modifiers";
    }
};
var showRecordFieldsCons1 = /* #__PURE__ */ Data_Show.showRecordFieldsCons(modifiersIsSymbol);
var productIdIsSymbol = {
    reflectSymbol: function () {
        return "productId";
    }
};
var showMap = /* #__PURE__ */ Data_Map_Serialized.showMap(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId);
var showMap1 = /* #__PURE__ */ showMap(/* #__PURE__ */ Data_MultiSet_Serialized.showMultiSet(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId));
var showMap2 = /* #__PURE__ */ showMap(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId);
var CartProductPartKeyIsSymbol = {
    reflectSymbol: function () {
        return "CartProductPartKey";
    }
};
var decodeRecord1 = /* #__PURE__ */ Unscramble.decodeRecord1();
var udecodeMap = /* #__PURE__ */ Data_Map_Serialized.udecodeMap(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.ufromJSONKey);
var decodeRecordCons = /* #__PURE__ */ Unscramble.decodeRecordCons(customParametersIsSymbol)(/* #__PURE__ */ udecodeMap(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId));
var decodeRecordCons1 = /* #__PURE__ */ Unscramble.decodeRecordCons(modifiersIsSymbol)(/* #__PURE__ */ udecodeMap(/* #__PURE__ */ Data_MultiSet_Serialized.udecodeMultiSet(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId)));
var partsIsSymbol = {
    reflectSymbol: function () {
        return "parts";
    }
};
var CartProductKeyIsSymbol = {
    reflectSymbol: function () {
        return "CartProductKey";
    }
};
var comboChoiceIdIsSymbol = {
    reflectSymbol: function () {
        return "comboChoiceId";
    }
};
var CartComboElementKeyIsSymbol = {
    reflectSymbol: function () {
        return "CartComboElementKey";
    }
};
var comboIdIsSymbol = {
    reflectSymbol: function () {
        return "comboId";
    }
};
var elementsIsSymbol = {
    reflectSymbol: function () {
        return "elements";
    }
};
var CartComboKeyIsSymbol = {
    reflectSymbol: function () {
        return "CartComboKey";
    }
};
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId);
var genericEncodeArgsArgument = /* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(encodeWithOptionsOther);
var genericEncodeArgsProduct = /* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsProduct(genericEncodeArgsArgument)(genericEncodeArgsArgument);
var encodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord();
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeRecordCons1 = /* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil);
var encodeMap = /* #__PURE__ */ Data_Map_Serialized.encodeMap(Restaumatic_Menu_V2_Types_Ids_EntityId.asJSONKeyEntityId);
var encodeMultiSet = /* #__PURE__ */ Data_MultiSet_Serialized.encodeMultiSet(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId);
var encodeWithOptionsOther1 = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ encodeMap(encodeMultiSet)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeMultiSet))));
var encodeWithOptionsOther2 = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ encodeMap(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId)(genericEncodeArgsArgument));
var decodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId);
var genericDecodeArgsArgument = /* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(decodeWithOptionsOther);
var genericDecodeArgsProduct = /* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsProduct(genericDecodeArgsArgument)(genericDecodeArgsArgument);
var genericCountArgsProduct = /* #__PURE__ */ Foreign_Generic_Class.genericCountArgsProduct(Foreign_Generic_Class.genericCountArgsArgument)(Foreign_Generic_Class.genericCountArgsArgument);
var decodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord();
var decodeRecordCons2 = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var decodeRecordCons3 = /* #__PURE__ */ decodeRecordCons2(Foreign_Generic_Class.decodeRecordNil);
var decodeMap = /* #__PURE__ */ Data_Map_Serialized.decodeMap(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.asJSONKeyEntityId);
var decodeMultiSet = /* #__PURE__ */ Data_MultiSet_Serialized.decodeMultiSet(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId);
var decodeWithOptionsOther1 = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ decodeMap(decodeMultiSet)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeMultiSet))));
var decodeWithOptionsOther2 = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ decodeMap(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)(genericDecodeArgsArgument));
var ParameterChoiceNotAvailable = /* #__PURE__ */ (function () {
    function ParameterChoiceNotAvailable(value0) {
        this.value0 = value0;
    };
    ParameterChoiceNotAvailable.create = function (value0) {
        return new ParameterChoiceNotAvailable(value0);
    };
    return ParameterChoiceNotAvailable;
})();
var InvalidModifierItemCount = /* #__PURE__ */ (function () {
    function InvalidModifierItemCount(value0) {
        this.value0 = value0;
    };
    InvalidModifierItemCount.create = function (value0) {
        return new InvalidModifierItemCount(value0);
    };
    return InvalidModifierItemCount;
})();
var InvalidModifierItemDuplicateCount = /* #__PURE__ */ (function () {
    function InvalidModifierItemDuplicateCount(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    InvalidModifierItemDuplicateCount.create = function (value0) {
        return function (value1) {
            return new InvalidModifierItemDuplicateCount(value0, value1);
        };
    };
    return InvalidModifierItemDuplicateCount;
})();
var ModifierItemNotAvailable = /* #__PURE__ */ (function () {
    function ModifierItemNotAvailable(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    ModifierItemNotAvailable.create = function (value0) {
        return function (value1) {
            return new ModifierItemNotAvailable(value0, value1);
        };
    };
    return ModifierItemNotAvailable;
})();
var IrremovableModifierItem = /* #__PURE__ */ (function () {
    function IrremovableModifierItem(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    IrremovableModifierItem.create = function (value0) {
        return function (value1) {
            return new IrremovableModifierItem(value0, value1);
        };
    };
    return IrremovableModifierItem;
})();
var ComboNotAvailable = /* #__PURE__ */ (function () {
    function ComboNotAvailable(value0) {
        this.value0 = value0;
    };
    ComboNotAvailable.create = function (value0) {
        return new ComboNotAvailable(value0);
    };
    return ComboNotAvailable;
})();
var ProductNotAvailable = /* #__PURE__ */ (function () {
    function ProductNotAvailable(value0) {
        this.value0 = value0;
    };
    ProductNotAvailable.create = function (value0) {
        return new ProductNotAvailable(value0);
    };
    return ProductNotAvailable;
})();
var MissingParameters = /* #__PURE__ */ (function () {
    function MissingParameters(value0) {
        this.value0 = value0;
    };
    MissingParameters.create = function (value0) {
        return new MissingParameters(value0);
    };
    return MissingParameters;
})();
var MissingValue = /* #__PURE__ */ (function () {
    function MissingValue() {

    };
    MissingValue.value = new MissingValue();
    return MissingValue;
})();
var ProductNotFound = /* #__PURE__ */ (function () {
    function ProductNotFound(value0) {
        this.value0 = value0;
    };
    ProductNotFound.create = function (value0) {
        return new ProductNotFound(value0);
    };
    return ProductNotFound;
})();
var CategoryNotFound = /* #__PURE__ */ (function () {
    function CategoryNotFound() {

    };
    CategoryNotFound.value = new CategoryNotFound();
    return CategoryNotFound;
})();
var DistinctCategories = /* #__PURE__ */ (function () {
    function DistinctCategories() {

    };
    DistinctCategories.value = new DistinctCategories();
    return DistinctCategories;
})();
var TooManyParts = /* #__PURE__ */ (function () {
    function TooManyParts() {

    };
    TooManyParts.value = new TooManyParts();
    return TooManyParts;
})();
var ParameterNotFound = /* #__PURE__ */ (function () {
    function ParameterNotFound(value0) {
        this.value0 = value0;
    };
    ParameterNotFound.create = function (value0) {
        return new ParameterNotFound(value0);
    };
    return ParameterNotFound;
})();
var ParametricError = /* #__PURE__ */ (function () {
    function ParametricError(value0) {
        this.value0 = value0;
    };
    ParametricError.create = function (value0) {
        return new ParametricError(value0);
    };
    return ParametricError;
})();
var CustomParameterNotSet = /* #__PURE__ */ (function () {
    function CustomParameterNotSet(value0) {
        this.value0 = value0;
    };
    CustomParameterNotSet.create = function (value0) {
        return new CustomParameterNotSet(value0);
    };
    return CustomParameterNotSet;
})();
var InternalParameterNotSet = /* #__PURE__ */ (function () {
    function InternalParameterNotSet(value0) {
        this.value0 = value0;
    };
    InternalParameterNotSet.create = function (value0) {
        return new InternalParameterNotSet(value0);
    };
    return InternalParameterNotSet;
})();
var InvalidParameterValue = /* #__PURE__ */ (function () {
    function InvalidParameterValue(value0) {
        this.value0 = value0;
    };
    InvalidParameterValue.create = function (value0) {
        return new InvalidParameterValue(value0);
    };
    return InvalidParameterValue;
})();
var ModifierNotFound = /* #__PURE__ */ (function () {
    function ModifierNotFound(value0) {
        this.value0 = value0;
    };
    ModifierNotFound.create = function (value0) {
        return new ModifierNotFound(value0);
    };
    return ModifierNotFound;
})();
var ModifierNotSet = /* #__PURE__ */ (function () {
    function ModifierNotSet(value0) {
        this.value0 = value0;
    };
    ModifierNotSet.create = function (value0) {
        return new ModifierNotSet(value0);
    };
    return ModifierNotSet;
})();
var InvalidModifierValue = /* #__PURE__ */ (function () {
    function InvalidModifierValue(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    InvalidModifierValue.create = function (value0) {
        return function (value1) {
            return new InvalidModifierValue(value0, value1);
        };
    };
    return InvalidModifierValue;
})();
var ComboNotFound = /* #__PURE__ */ (function () {
    function ComboNotFound(value0) {
        this.value0 = value0;
    };
    ComboNotFound.create = function (value0) {
        return new ComboNotFound(value0);
    };
    return ComboNotFound;
})();
var ComboElementNotSet = /* #__PURE__ */ (function () {
    function ComboElementNotSet(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    ComboElementNotSet.create = function (value0) {
        return function (value1) {
            return new ComboElementNotSet(value0, value1);
        };
    };
    return ComboElementNotSet;
})();
var InvalidComboChoice = /* #__PURE__ */ (function () {
    function InvalidComboChoice(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    InvalidComboChoice.create = function (value0) {
        return function (value1) {
            return new InvalidComboChoice(value0, value1);
        };
    };
    return InvalidComboChoice;
})();
var AvailabilityScheduleNotFound = /* #__PURE__ */ (function () {
    function AvailabilityScheduleNotFound(value0) {
        this.value0 = value0;
    };
    AvailabilityScheduleNotFound.create = function (value0) {
        return new AvailabilityScheduleNotFound(value0);
    };
    return AvailabilityScheduleNotFound;
})();
var VariantNotAvailable = /* #__PURE__ */ (function () {
    function VariantNotAvailable(value0) {
        this.value0 = value0;
    };
    VariantNotAvailable.create = function (value0) {
        return new VariantNotAvailable(value0);
    };
    return VariantNotAvailable;
})();
var PackagingContainerNotFound = /* #__PURE__ */ (function () {
    function PackagingContainerNotFound(value0) {
        this.value0 = value0;
    };
    PackagingContainerNotFound.create = function (value0) {
        return new PackagingContainerNotFound(value0);
    };
    return PackagingContainerNotFound;
})();
var CartProductPartKey = function (x) {
    return x;
};
var CartProductKey = function (x) {
    return x;
};
var CartComboElementKey = function (x) {
    return x;
};
var CartComboKey = function (x) {
    return x;
};
var toFillFormTypeSoftError = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var toFillFormTypeSimpleParam = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var toFillFormTypeFatalError = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var toFillFormTypeCartProduct = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var toFillFormTypeCartProduct1 = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var toFillFormTypeCartComboKe = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var toFillFormTypeCartComboEl = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypeCartProductPartKey = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeCartProductKey_ = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeCartComboKey_ = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeCartComboElementKe = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldCartProductPartKe = function (dictHasField) {
    return dictHasField;
};
var hasFieldCartProductKey = function (dictHasField) {
    return dictHasField;
};
var hasFieldCartComboKey = function (dictHasField) {
    return dictHasField;
};
var hasFieldCartComboElementK = function (dictHasField) {
    return dictHasField;
};
var eqSoftError = {
    eq: function (x) {
        return function (y) {
            if (x instanceof ParameterChoiceNotAvailable && y instanceof ParameterChoiceNotAvailable) {
                return eq(x.value0)(y.value0);
            };
            if (x instanceof InvalidModifierItemCount && y instanceof InvalidModifierItemCount) {
                return eq(x.value0)(y.value0);
            };
            if (x instanceof InvalidModifierItemDuplicateCount && y instanceof InvalidModifierItemDuplicateCount) {
                return eq(x.value0)(y.value0) && eq(x.value1)(y.value1);
            };
            if (x instanceof ModifierItemNotAvailable && y instanceof ModifierItemNotAvailable) {
                return eq(x.value0)(y.value0) && eq(x.value1)(y.value1);
            };
            if (x instanceof IrremovableModifierItem && y instanceof IrremovableModifierItem) {
                return eq(x.value0)(y.value0) && eq(x.value1)(y.value1);
            };
            if (x instanceof ComboNotAvailable && y instanceof ComboNotAvailable) {
                return eq(x.value0)(y.value0);
            };
            if (x instanceof ProductNotAvailable && y instanceof ProductNotAvailable) {
                return eq(x.value0)(y.value0);
            };
            return false;
        };
    }
};
var eqSimpleParametricEvaluat = {
    eq: function (x) {
        return function (y) {
            if (x instanceof MissingParameters && y instanceof MissingParameters) {
                return eq1(x.value0)(y.value0);
            };
            if (x instanceof MissingValue && y instanceof MissingValue) {
                return true;
            };
            return false;
        };
    }
};
var eq5 = /* #__PURE__ */ Data_Eq.eq(eqSimpleParametricEvaluat);
var eqFatalError = {
    eq: function (x) {
        return function (y) {
            if (x instanceof ProductNotFound && y instanceof ProductNotFound) {
                return eq(x.value0)(y.value0);
            };
            if (x instanceof CategoryNotFound && y instanceof CategoryNotFound) {
                return true;
            };
            if (x instanceof DistinctCategories && y instanceof DistinctCategories) {
                return true;
            };
            if (x instanceof TooManyParts && y instanceof TooManyParts) {
                return true;
            };
            if (x instanceof ParameterNotFound && y instanceof ParameterNotFound) {
                return eq(x.value0)(y.value0);
            };
            if (x instanceof ParametricError && y instanceof ParametricError) {
                return eq5(x.value0)(y.value0);
            };
            if (x instanceof CustomParameterNotSet && y instanceof CustomParameterNotSet) {
                return eq(x.value0)(y.value0);
            };
            if (x instanceof InternalParameterNotSet && y instanceof InternalParameterNotSet) {
                return eq2(x.value0)(y.value0);
            };
            if (x instanceof InvalidParameterValue && y instanceof InvalidParameterValue) {
                return eq(x.value0)(y.value0);
            };
            if (x instanceof ModifierNotFound && y instanceof ModifierNotFound) {
                return eq(x.value0)(y.value0);
            };
            if (x instanceof ModifierNotSet && y instanceof ModifierNotSet) {
                return eq(x.value0)(y.value0);
            };
            if (x instanceof InvalidModifierValue && y instanceof InvalidModifierValue) {
                return eq(x.value0)(y.value0) && eq(x.value1)(y.value1);
            };
            if (x instanceof ComboNotFound && y instanceof ComboNotFound) {
                return eq(x.value0)(y.value0);
            };
            if (x instanceof ComboElementNotSet && y instanceof ComboElementNotSet) {
                return eq(x.value0)(y.value0) && eq(x.value1)(y.value1);
            };
            if (x instanceof InvalidComboChoice && y instanceof InvalidComboChoice) {
                return eq(x.value0)(y.value0) && eq(x.value1)(y.value1);
            };
            if (x instanceof AvailabilityScheduleNotFound && y instanceof AvailabilityScheduleNotFound) {
                return eq(x.value0)(y.value0);
            };
            if (x instanceof VariantNotAvailable && y instanceof VariantNotAvailable) {
                return eq(x.value0)(y.value0);
            };
            if (x instanceof PackagingContainerNotFound && y instanceof PackagingContainerNotFound) {
                return eq(x.value0)(y.value0);
            };
            return false;
        };
    }
};
var eqCartProductPartKey = {
    eq: function (x) {
        return function (y) {
            return eq3(x.customParameters)(y.customParameters) && eq4(x.modifiers)(y.modifiers) && eq(x.productId)(y.productId);
        };
    }
};
var eq6 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Array_NonEmpty_Serialized.eqNonEmptyArray(eqCartProductPartKey));
var ordCartProductPartKey = {
    compare: function (x) {
        return function (y) {
            var v = compare(x.customParameters)(y.customParameters);
            if (v instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            var v1 = compare1(x.modifiers)(y.modifiers);
            if (v1 instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v1 instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            return compare2(x.productId)(y.productId);
        };
    },
    Eq0: function () {
        return eqCartProductPartKey;
    }
};
var compare3 = /* #__PURE__ */ Data_Ord.compare(/* #__PURE__ */ Data_Array_NonEmpty_Serialized.ordNonEmptyArray(ordCartProductPartKey));
var eqCartProductKey = {
    eq: function (x) {
        return function (y) {
            return eq3(x.customParameters)(y.customParameters) && eq4(x.modifiers)(y.modifiers) && eq6(x.parts)(y.parts);
        };
    }
};
var ordCartProductKey = {
    compare: function (x) {
        return function (y) {
            var v = compare(x.customParameters)(y.customParameters);
            if (v instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            var v1 = compare1(x.modifiers)(y.modifiers);
            if (v1 instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v1 instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            return compare3(x.parts)(y.parts);
        };
    },
    Eq0: function () {
        return eqCartProductKey;
    }
};
var eqCartComboElementKey = {
    eq: function (x) {
        return function (y) {
            return eq(x.comboChoiceId)(y.comboChoiceId) && eq3(x.customParameters)(y.customParameters) && eq4(x.modifiers)(y.modifiers);
        };
    }
};
var eq7 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ eqMap(eqCartComboElementKey));
var eqCartComboKey = {
    eq: function (x) {
        return function (y) {
            return eq(x.comboId)(y.comboId) && eq7(x.elements)(y.elements);
        };
    }
};
var ordCartComboElementKey = {
    compare: function (x) {
        return function (y) {
            var v = compare2(x.comboChoiceId)(y.comboChoiceId);
            if (v instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            var v1 = compare(x.customParameters)(y.customParameters);
            if (v1 instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v1 instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            return compare1(x.modifiers)(y.modifiers);
        };
    },
    Eq0: function () {
        return eqCartComboElementKey;
    }
};
var compare4 = /* #__PURE__ */ Data_Ord.compare(/* #__PURE__ */ ordMap(ordCartComboElementKey));
var ordCartComboKey = {
    compare: function (x) {
        return function (y) {
            var v = compare2(x.comboId)(y.comboId);
            if (v instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            return compare4(x.elements)(y.elements);
        };
    },
    Eq0: function () {
        return eqCartComboKey;
    }
};
var genericSoftError = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new ParameterChoiceNotAvailable(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new InvalidModifierItemCount(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new InvalidModifierItemDuplicateCount(x.value0.value0.value0.value0, x.value0.value0.value0.value1);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return new ModifierItemNotAvailable(x.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value1);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return new IrremovableModifierItem(x.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value1);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return new ComboNotAvailable(x.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))) {
            return new ProductNotAvailable(x.value0.value0.value0.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.CartToOrder (line 32, column 1 - line 32, column 73): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof ParameterChoiceNotAvailable) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof InvalidModifierItemCount) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof InvalidModifierItemDuplicateCount) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1))));
        };
        if (x instanceof ModifierItemNotAvailable) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1)))));
        };
        if (x instanceof IrremovableModifierItem) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1))))));
        };
        if (x instanceof ComboNotAvailable) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))));
        };
        if (x instanceof ProductNotAvailable) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))))));
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.CartToOrder (line 32, column 1 - line 32, column 73): " + [ x.constructor.name ]);
    }
};
var showSoftError = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericSoftError)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(ParameterChoiceNotAvailableIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(InvalidModifierItemCountIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor1(InvalidModifierItemDuplicateCountIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor1(ModifierItemNotAvailableIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor1(IrremovableModifierItemIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(ComboNotAvailableIsSymbol))(/* #__PURE__ */ genericShowConstructor(ProductNotAvailableIsSymbol))))))))
};
var unscrambleDecodeSoftError = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericSoftError)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(ParameterChoiceNotAvailableIsSymbol)(decodeSingleConstructorAr1))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(InvalidModifierItemCountIsSymbol)(decodeSingleConstructorAr1))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(InvalidModifierItemDuplicateCountIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(ModifierItemNotAvailableIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(IrremovableModifierItemIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(ComboNotAvailableIsSymbol)(decodeSingleConstructorAr1))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(ProductNotAvailableIsSymbol)(decodeSingleConstructorAr1)))))))))(Unscramble_Generic.defaultOptions)
};
var genericSimpleParametricEvaluationError = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new MissingParameters(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return MissingValue.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.CartToOrder (line 58, column 1 - line 58, column 117): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof MissingParameters) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof MissingValue) {
            return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.CartToOrder (line 58, column 1 - line 58, column 117): " + [ x.constructor.name ]);
    }
};
var showSimpleParametricEvaluationError = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericSimpleParametricEvaluationError)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Set_Serialized.showSet(Restaumatic_Menu_V2_Types_ParameterId.showParameterId)))(MissingParametersIsSymbol))(/* #__PURE__ */ genericShowConstructor2(MissingValueIsSymbol)))
};
var unscrambleDecodeSimpleParametricEvaluationError = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericSimpleParametricEvaluationError)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(MissingParametersIsSymbol)(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(/* #__PURE__ */ Data_Set_Serialized.udecodeSet(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId)(Restaumatic_Menu_V2_Types_ParameterId.unscrambleDecodeParameterId))))(/* #__PURE__ */ genericDecodeSumConstruct11(MissingValueIsSymbol))))(Unscramble_Generic.defaultOptions)
};
var genericFatalError = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new ProductNotFound(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return CategoryNotFound.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return DistinctCategories.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return TooManyParts.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return new ParameterNotFound(x.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return new ParametricError(x.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
            return new CustomParameterNotSet(x.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
            return new InternalParameterNotSet(x.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))) {
            return new InvalidParameterValue(x.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))) {
            return new ModifierNotFound(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))) {
            return new ModifierNotSet(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))) {
            return new InvalidModifierValue(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value1);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))) {
            return new ComboNotFound(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))) {
            return new ComboElementNotSet(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value1);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))) {
            return new InvalidComboChoice(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value1);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))))) {
            return new AvailabilityScheduleNotFound(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))))) {
            return new VariantNotAvailable(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))))))))))))))) {
            return new PackagingContainerNotFound(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.CartToOrder (line 82, column 1 - line 82, column 75): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof ProductNotFound) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof CategoryNotFound) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof DistinctCategories) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof TooManyParts) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof ParameterNotFound) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
        };
        if (x instanceof ParametricError) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))));
        };
        if (x instanceof CustomParameterNotSet) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))));
        };
        if (x instanceof InternalParameterNotSet) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))));
        };
        if (x instanceof InvalidParameterValue) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))));
        };
        if (x instanceof ModifierNotFound) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))))));
        };
        if (x instanceof ModifierNotSet) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))))));
        };
        if (x instanceof InvalidModifierValue) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1)))))))))))));
        };
        if (x instanceof ComboNotFound) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))))))));
        };
        if (x instanceof ComboElementNotSet) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1)))))))))))))));
        };
        if (x instanceof InvalidComboChoice) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1))))))))))))))));
        };
        if (x instanceof AvailabilityScheduleNotFound) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))))))))))));
        };
        if (x instanceof VariantNotAvailable) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))))))))))));
        };
        if (x instanceof PackagingContainerNotFound) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)))))))))))))))));
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.CartToOrder (line 82, column 1 - line 82, column 75): " + [ x.constructor.name ]);
    }
};
var showFatalError = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericFatalError)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(ProductNotFoundIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor2(CategoryNotFoundIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor2(DistinctCategoriesIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor2(TooManyPartsIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(ParameterNotFoundIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(showSimpleParametricEvaluationError))(ParametricErrorIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(CustomParameterNotSetIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Restaumatic_Menu_V2_Types_InternalParameterId.showInternalParameterId))(InternalParameterNotSetIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(InvalidParameterValueIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(ModifierNotFoundIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(ModifierNotSetIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor1(InvalidModifierValueIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(ComboNotFoundIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor1(ComboElementNotSetIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor1(InvalidComboChoiceIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(AvailabilityScheduleNotFoundIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(VariantNotAvailableIsSymbol))(/* #__PURE__ */ genericShowConstructor(PackagingContainerNotFoundIsSymbol)))))))))))))))))))
};
var unscrambleDecodeFatalError = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericFatalError)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(ProductNotFoundIsSymbol)(decodeSingleConstructorAr1))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct11(CategoryNotFoundIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct11(DistinctCategoriesIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct11(TooManyPartsIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(ParameterNotFoundIsSymbol)(decodeSingleConstructorAr1))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(ParametricErrorIsSymbol)(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(unscrambleDecodeSimpleParametricEvaluationError)))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(CustomParameterNotSetIsSymbol)(decodeSingleConstructorAr1))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(InternalParameterNotSetIsSymbol)(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Restaumatic_Menu_V2_Types_InternalParameterId.unscrambleDecodeInternalParameterId)))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(InvalidParameterValueIsSymbol)(decodeSingleConstructorAr1))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(ModifierNotFoundIsSymbol)(decodeSingleConstructorAr1))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(ModifierNotSetIsSymbol)(decodeSingleConstructorAr1))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(InvalidModifierValueIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(ComboNotFoundIsSymbol)(decodeSingleConstructorAr1))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(ComboElementNotSetIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(InvalidComboChoiceIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(AvailabilityScheduleNotFoundIsSymbol)(decodeSingleConstructorAr1))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(VariantNotAvailableIsSymbol)(decodeSingleConstructorAr1))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(PackagingContainerNotFoundIsSymbol)(decodeSingleConstructorAr1))))))))))))))))))))(Unscramble_Generic.defaultOptions)
};
var genericCartProductPartKey = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showCartProductPartKey = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCartProductPartKey)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons(/* #__PURE__ */ showRecordFieldsCons1(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(productIdIsSymbol)(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId))(showMap1))(showMap2))))(CartProductPartKeyIsSymbol))
};
var unscrambleDecodeCartProductPartKey = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericCartProductPartKey)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ decodeRecord1(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons1(/* #__PURE__ */ Unscramble.decodeRecordCons(productIdIsSymbol)(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId)(Unscramble.decodeRecordNil)))))))(Unscramble_Generic.defaultOptions)
};
var genericCartProductKey = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showCartProductKey = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCartProductKey)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons(/* #__PURE__ */ showRecordFieldsCons1(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(partsIsSymbol)(/* #__PURE__ */ Data_Array_NonEmpty_Serialized.showNonEmptyArray(showCartProductPartKey)))(showMap1))(showMap2))))(CartProductKeyIsSymbol))
};
var unscrambleDecodeCartProductKey = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericCartProductKey)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ decodeRecord1(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons1(/* #__PURE__ */ Unscramble.decodeRecordCons(partsIsSymbol)(/* #__PURE__ */ Data_Array_NonEmpty_Serialized.udecodeNonEmptyArray(unscrambleDecodeCartProductPartKey))(Unscramble.decodeRecordNil)))))))(Unscramble_Generic.defaultOptions)
};
var genericCartComboKey = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericCartComboElementKey = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showCartComboElementKey = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCartComboElementKey)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(comboChoiceIdIsSymbol)(/* #__PURE__ */ showRecordFieldsCons(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(modifiersIsSymbol)(showMap1))(showMap2))(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId))))(CartComboElementKeyIsSymbol))
};
var showCartComboKey = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCartComboKey)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(comboIdIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(elementsIsSymbol)(/* #__PURE__ */ showMap(showCartComboElementKey)))(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId))))(CartComboKeyIsSymbol))
};
var unscrambleDecodeCartComboElementKey = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericCartComboElementKey)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ decodeRecord1(/* #__PURE__ */ Unscramble.decodeRecordCons(comboChoiceIdIsSymbol)(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId)(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons1(Unscramble.decodeRecordNil)))))))(Unscramble_Generic.defaultOptions)
};
var unscrambleDecodeCartComboKey = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericCartComboKey)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ decodeRecord1(/* #__PURE__ */ Unscramble.decodeRecordCons(comboIdIsSymbol)(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId)(/* #__PURE__ */ Unscramble.decodeRecordCons(elementsIsSymbol)(/* #__PURE__ */ udecodeMap(unscrambleDecodeCartComboElementKey))(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var encodeSoftError = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericSoftError)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ParameterChoiceNotAvailableIsSymbol)(genericEncodeArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(InvalidModifierItemCountIsSymbol)(genericEncodeArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(InvalidModifierItemDuplicateCountIsSymbol)(genericEncodeArgsProduct))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ModifierItemNotAvailableIsSymbol)(genericEncodeArgsProduct))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(IrremovableModifierItemIsSymbol)(genericEncodeArgsProduct))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ComboNotAvailableIsSymbol)(genericEncodeArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ProductNotAvailableIsSymbol)(genericEncodeArgsArgument))))))))
};
var encodeSimpleParametricEvaluationError = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericSimpleParametricEvaluationError)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(MissingParametersIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Data_Set_Serialized.encodeSet(Restaumatic_Menu_V2_Types_ParameterId.encodeParameterId)))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(MissingValueIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments)))
};
var encodeFatalError = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericFatalError)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ProductNotFoundIsSymbol)(genericEncodeArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(CategoryNotFoundIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(DistinctCategoriesIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(TooManyPartsIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ParameterNotFoundIsSymbol)(genericEncodeArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ParametricErrorIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeSimpleParametricEvaluationError))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(CustomParameterNotSetIsSymbol)(genericEncodeArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(InternalParameterNotSetIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_InternalParameterId.encodeInternalParameterId))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(InvalidParameterValueIsSymbol)(genericEncodeArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ModifierNotFoundIsSymbol)(genericEncodeArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ModifierNotSetIsSymbol)(genericEncodeArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(InvalidModifierValueIsSymbol)(genericEncodeArgsProduct))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ComboNotFoundIsSymbol)(genericEncodeArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ComboElementNotSetIsSymbol)(genericEncodeArgsProduct))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(InvalidComboChoiceIsSymbol)(genericEncodeArgsProduct))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(AvailabilityScheduleNotFoundIsSymbol)(genericEncodeArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(VariantNotAvailableIsSymbol)(genericEncodeArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(PackagingContainerNotFoundIsSymbol)(genericEncodeArgsArgument)))))))))))))))))))
};
var encodeCartProductPartKey = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericCartProductPartKey)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(CartProductPartKeyIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(productIdIsSymbol)(encodeWithOptionsOther))(modifiersIsSymbol)(encodeWithOptionsOther1))(customParametersIsSymbol)(encodeWithOptionsOther2)))))
};
var encodeCartProductKey = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericCartProductKey)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(CartProductKeyIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(partsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Data_Array_NonEmpty_Serialized.encodeNonEmptyArray(encodeCartProductPartKey))))(modifiersIsSymbol)(encodeWithOptionsOther1))(customParametersIsSymbol)(encodeWithOptionsOther2)))))
};
var encodeCartComboElementKey = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericCartComboElementKey)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(CartComboElementKeyIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(modifiersIsSymbol)(encodeWithOptionsOther1))(customParametersIsSymbol)(encodeWithOptionsOther2))(comboChoiceIdIsSymbol)(encodeWithOptionsOther)))))
};
var encodeCartComboKey = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericCartComboKey)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(CartComboKeyIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(elementsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ encodeMap(encodeCartComboElementKey)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeCartComboElementKey))))))(comboIdIsSymbol)(encodeWithOptionsOther)))))
};
var decodeSoftError = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericSoftError)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ParameterChoiceNotAvailableIsSymbol)(genericDecodeArgsArgument)(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(InvalidModifierItemCountIsSymbol)(genericDecodeArgsArgument)(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(InvalidModifierItemDuplicateCountIsSymbol)(genericDecodeArgsProduct)(genericCountArgsProduct))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ModifierItemNotAvailableIsSymbol)(genericDecodeArgsProduct)(genericCountArgsProduct))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(IrremovableModifierItemIsSymbol)(genericDecodeArgsProduct)(genericCountArgsProduct))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ComboNotAvailableIsSymbol)(genericDecodeArgsArgument)(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ProductNotAvailableIsSymbol)(genericDecodeArgsArgument)(Foreign_Generic_Class.genericCountArgsArgument))))))))
};
var decodeSimpleParametricEvaluationError = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericSimpleParametricEvaluationError)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(MissingParametersIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Data_Set_Serialized.decodeSet(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId)(Restaumatic_Menu_V2_Types_ParameterId.decodeParameterId))))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(MissingValueIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments)))
};
var decodeFatalError = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericFatalError)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ProductNotFoundIsSymbol)(genericDecodeArgsArgument)(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(CategoryNotFoundIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(DistinctCategoriesIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(TooManyPartsIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ParameterNotFoundIsSymbol)(genericDecodeArgsArgument)(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ParametricErrorIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeSimpleParametricEvaluationError)))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(CustomParameterNotSetIsSymbol)(genericDecodeArgsArgument)(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(InternalParameterNotSetIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_InternalParameterId.decodeInternalParameterId)))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(InvalidParameterValueIsSymbol)(genericDecodeArgsArgument)(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ModifierNotFoundIsSymbol)(genericDecodeArgsArgument)(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ModifierNotSetIsSymbol)(genericDecodeArgsArgument)(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(InvalidModifierValueIsSymbol)(genericDecodeArgsProduct)(genericCountArgsProduct))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ComboNotFoundIsSymbol)(genericDecodeArgsArgument)(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ComboElementNotSetIsSymbol)(genericDecodeArgsProduct)(genericCountArgsProduct))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(InvalidComboChoiceIsSymbol)(genericDecodeArgsProduct)(genericCountArgsProduct))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(AvailabilityScheduleNotFoundIsSymbol)(genericDecodeArgsArgument)(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(VariantNotAvailableIsSymbol)(genericDecodeArgsArgument)(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(PackagingContainerNotFoundIsSymbol)(genericDecodeArgsArgument)(Foreign_Generic_Class.genericCountArgsArgument)))))))))))))))))))
};
var decodeCartProductPartKey = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericCartProductPartKey)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(CartProductPartKeyIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons2(/* #__PURE__ */ decodeRecordCons2(/* #__PURE__ */ decodeRecordCons3(productIdIsSymbol)(decodeWithOptionsOther)())(modifiersIsSymbol)(decodeWithOptionsOther1)())(customParametersIsSymbol)(decodeWithOptionsOther2)())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeCartProductKey = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericCartProductKey)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(CartProductKeyIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons2(/* #__PURE__ */ decodeRecordCons2(/* #__PURE__ */ decodeRecordCons3(partsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Data_Array_NonEmpty_Serialized.decodeNonEmptyArray(decodeCartProductPartKey)))())(modifiersIsSymbol)(decodeWithOptionsOther1)())(customParametersIsSymbol)(decodeWithOptionsOther2)())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeCartComboElementKey = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericCartComboElementKey)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(CartComboElementKeyIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons2(/* #__PURE__ */ decodeRecordCons2(/* #__PURE__ */ decodeRecordCons3(modifiersIsSymbol)(decodeWithOptionsOther1)())(customParametersIsSymbol)(decodeWithOptionsOther2)())(comboChoiceIdIsSymbol)(decodeWithOptionsOther)())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeCartComboKey = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericCartComboKey)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(CartComboKeyIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons2(/* #__PURE__ */ decodeRecordCons3(elementsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ decodeMap(decodeCartComboElementKey)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeCartComboElementKey)))))())(comboIdIsSymbol)(decodeWithOptionsOther)())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    ParameterChoiceNotAvailable,
    InvalidModifierItemCount,
    InvalidModifierItemDuplicateCount,
    ModifierItemNotAvailable,
    IrremovableModifierItem,
    ComboNotAvailable,
    ProductNotAvailable,
    MissingParameters,
    MissingValue,
    ProductNotFound,
    CategoryNotFound,
    DistinctCategories,
    TooManyParts,
    ParameterNotFound,
    ParametricError,
    CustomParameterNotSet,
    InternalParameterNotSet,
    InvalidParameterValue,
    ModifierNotFound,
    ModifierNotSet,
    InvalidModifierValue,
    ComboNotFound,
    ComboElementNotSet,
    InvalidComboChoice,
    AvailabilityScheduleNotFound,
    VariantNotAvailable,
    PackagingContainerNotFound,
    CartProductPartKey,
    CartProductKey,
    CartComboKey,
    CartComboElementKey,
    genericSoftError,
    eqSoftError,
    showSoftError,
    encodeSoftError,
    decodeSoftError,
    unscrambleDecodeSoftError,
    toFillFormTypeSoftError,
    genericSimpleParametricEvaluationError,
    eqSimpleParametricEvaluat,
    showSimpleParametricEvaluationError,
    encodeSimpleParametricEvaluationError,
    decodeSimpleParametricEvaluationError,
    unscrambleDecodeSimpleParametricEvaluationError,
    toFillFormTypeSimpleParam,
    genericFatalError,
    eqFatalError,
    showFatalError,
    encodeFatalError,
    decodeFatalError,
    unscrambleDecodeFatalError,
    toFillFormTypeFatalError,
    genericCartProductPartKey,
    eqCartProductPartKey,
    showCartProductPartKey,
    ordCartProductPartKey,
    encodeCartProductPartKey,
    decodeCartProductPartKey,
    unscrambleDecodeCartProductPartKey,
    toFillFormTypeCartProduct1,
    hasFieldCartProductPartKe,
    newtypeCartProductPartKey,
    genericCartProductKey,
    eqCartProductKey,
    showCartProductKey,
    ordCartProductKey,
    encodeCartProductKey,
    decodeCartProductKey,
    unscrambleDecodeCartProductKey,
    toFillFormTypeCartProduct,
    hasFieldCartProductKey,
    newtypeCartProductKey_,
    genericCartComboKey,
    eqCartComboKey,
    showCartComboKey,
    ordCartComboKey,
    encodeCartComboKey,
    decodeCartComboKey,
    unscrambleDecodeCartComboKey,
    toFillFormTypeCartComboKe,
    hasFieldCartComboKey,
    newtypeCartComboKey_,
    genericCartComboElementKey,
    eqCartComboElementKey,
    showCartComboElementKey,
    ordCartComboElementKey,
    encodeCartComboElementKey,
    decodeCartComboElementKey,
    unscrambleDecodeCartComboElementKey,
    toFillFormTypeCartComboEl,
    hasFieldCartComboElementK,
    newtypeCartComboElementKe
};
